module.exports = __webpack_public_path__ + "static/media/samsungGalaxyS20Ultra.5c62fef9.jpeg";